var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6631 18.118C13.4566 20.5641 8.95105 19.8611 6.59977 16.5478C1.63284 9.54881 5.31015 2.12022 5.31015 2.12022C5.31015 2.12022 13.2448 0.690794 18.2118 7.68982C20.1773 10.4595 20.0153 14.1765 18.036 16.7505C18.6245 17.6493 19.1102 18.6203 19.4805 19.6442L19.952 20.9476C20.0976 21.3503 19.9008 21.7992 19.5124 21.9502C19.124 22.1012 18.6911 21.8972 18.5454 21.4945L18.074 20.1911C17.7806 19.3798 17.4055 18.6061 16.9567 17.882C16.8613 17.9627 16.7635 18.0415 16.6631 18.118ZM16.9567 17.882C17.3615 17.5392 17.7217 17.1593 18.036 16.7505C17.544 15.999 16.9801 15.298 16.3515 14.6587L16.3514 10.3189C16.3514 9.88883 16.0152 9.54019 15.6003 9.54019C15.1855 9.54019 14.8492 9.88884 14.8492 10.3189L14.8493 13.1483L11.2803 9.26284C10.9942 8.9514 10.5188 8.93936 10.2184 9.23596C9.91798 9.53256 9.90637 10.0255 10.1925 10.3369L13.2755 13.6933L11.7378 13.6934C11.3229 13.6934 10.9867 14.0421 10.9867 14.4722C10.9867 14.9022 11.323 15.2509 11.7378 15.2508L14.7457 15.2507L15.0966 15.569C15.8088 16.2595 16.433 17.0369 16.9567 17.882Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.061255a32d5071a883aa94e2694e3331.svg";
export { ForwardRef as ReactComponent };